import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { bshopList } from "api/bshop";

const initialState = {
  isLoading: false,
  isMoreData: true,
  page: 1,
  itemList: [],
  isError: false,
};

export const fetchBshopList = createAsyncThunk(
  "bshop/fetchBshopList",
  async (payload) => {
    return await bshopList(payload);
  },
);

const bshopSlice = createSlice({
  name: "bshop",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBshopList.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(fetchBshopList.fulfilled, (state, action) => {
        const { first, last, results } = action.payload;
        state.isLoading = false;
        if (first) {
          state.itemList = results;
        } else {
          state.itemList = state.itemList.concat(results);
        }
        state.page = state.page + 1;
        state.isMoreData = true;
        if (last) {
          state.isMoreData = false;
          state.page = 1;
        }
      })
      .addCase(fetchBshopList.rejected, (state) => {
        Object.assign(state, { ...initialState, isError: true });
      });
  },
});

export default bshopSlice.reducer;
